import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import PaymentSuccess from "./pages/PaymentSuccess";
import AllReviews from "./pages/AllReviews";
import About from "./pages/About";
import Contact from "./pages/Contact";
import FrenchTest from "./pages/FrenchTest";
import FrenchGrammarTest from "./pages/FrenchGrammarTest";
import EnglishLevelTest from "./pages/EnglishLevelTest";
import SpanishLevelTest from "./pages/SpanishLevelTest";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import Store from "./pages/Store";
import StoreSuccess from "./pages/StoreSuccess";
import CookieConsent from "./components/CookieConsent";
import { initGA, hasConsent } from "./utils/analytics";
import { usePageTracking } from "./hooks/usePageTracking";

function AppRoutes() {
  usePageTracking();
  
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/programs" element={<Home />} />
      <Route path="/pricing" element={<Home />} />
      <Route path="/language-coach" element={<Home />} />
      <Route path="/testimonials" element={<Home />} />
      <Route path="/book" element={<Home />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/reviews" element={<AllReviews />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/french-test" element={<FrenchTest />} />
      <Route path="/french-level-test" element={<FrenchGrammarTest />} />
      <Route path="/english-level-test" element={<EnglishLevelTest />} />
      <Route path="/spanish-level-test" element={<SpanishLevelTest />} />
      <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      <Route path="/store" element={<Store />} />
      <Route path="/store/success" element={<StoreSuccess />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    // Only initialize Google Analytics if user has already consented (mount only)
    if (hasConsent()) {
      initGA();
    }
  }, []);
  
  const handleAcceptCookies = () => {
    // Initialize Google Analytics when user accepts
    initGA();
  };
  
  const handleDeclineCookies = () => {
    // User declined cookies - analytics stays disabled
  };
  
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <CookieConsent 
        onAccept={handleAcceptCookies}
        onDecline={handleDeclineCookies}
      />
      <Toaster />
    </div>
  );
}

export default App;
